import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import isLogged from '../../services/isLogged'
import { LOGIN } from '../../navigation/constants'

// The backend has already validated the SSO flow and set the http-only refresh
// cookie, then redirected the browser here. We just warm the session (the existing
// isLogged() refresh → memory token) and route to the original target. No token
// handling in JS — this reuses the same hydration path as a normal page load.
export default function SsoCallback() {
  const history = useHistory()
  const search = useLocation().search

  useEffect(() => {
    const raw = new URLSearchParams(search).get('returnUrl') || '/select-warehouse'
    // Only honor in-app paths — never let returnUrl drive an external redirect.
    // "//host" and "/\host" are protocol-relative escapes, not in-app paths.
    const safe = raw.startsWith('/') && !raw.startsWith('//') && !raw.startsWith('/\\')
    const returnUrl = safe ? raw : '/select-warehouse'
    isLogged().then(ok => {
      history.replace(ok ? returnUrl : `${LOGIN}?sso_error=session`)
    })
  }, [history, search])

  return null
}
